var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketplacesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#00ff40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.411 21.927a3.05 3.05 0 1 1 6.099 0 3.05 3.05 0 0 1-6.099 0Zm7.794 7.454a3.388 3.388 0 0 0-3.389-3.388h-2.71a3.388 3.388 0 0 0-3.39 3.389v1.355h9.489v-1.355Zm7.285-7.454a3.05 3.05 0 1 0 6.099 0 3.05 3.05 0 0 0-6.1 0Zm4.405 4.066h-2.711a3.388 3.388 0 0 0-3.389 3.389v1.355h9.488v-1.355a3.388 3.388 0 0 0-3.388-3.389Zm-5.302 9.393c-.91.229-1.917.345-3.007.345-4.82 0-6.452-2.23-6.53-2.34a.847.847 0 0 0-1.405.946c.084.126 2.126 3.088 7.935 3.088 1.434 0 2.755-.182 3.937-.54l.898 1.448 2.395-4.466-5.065.158.842 1.36Zm-7.249-20.772c.911-.229 1.918-.345 3.008-.345 4.82 0 6.452 2.229 6.53 2.34a.847.847 0 0 0 1.405-.947c-.084-.126-2.126-3.087-7.935-3.087-1.434 0-2.755.182-3.937.54l-.898-1.449-2.395 4.466 5.065-.157-.843-1.36Z",
    fill: "#091812"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11.667 11.666)",
    d: "M0 0h26.667v26.667H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplacesIcon);
export default __webpack_public_path__ + "static/media/marketplaces-icon.290844df90d1de7ef6a13f0f41235357.svg";
export { ForwardRef as ReactComponent };